import React, { useEffect, useState } from 'react';
import Layout from './Layout';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../../../../components/button/button';
import Input from '../../../../components/input/Input';
import Label from '../../../../components/title/label';
import Table from '../../../../components/table/Table';
import axios from 'axios';
import DateFormatConverter from '../../../../components/input/DateFormatConvert';
import SearchInput from '../../../../components/input/SearchInput';
import { BACKEND_URL } from '../../../../constants/constant';

function MouvementHistorique() {
    const location = useLocation();
    const [history, setHistory] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [dataSelected, setDataSelected] = useState(null);

    useEffect(() => {
        // Récupérer les données depuis le backend
        axios.get(`${BACKEND_URL}/recette/history`)
            .then((response) => setHistory(response.data))
            .catch((error) => console.error(error));
    }, []);

    const filteredData = history.filter((item) => {
        const itemDate = new Date(item.date_creation);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;

        const matchesSearchTerm = item.numero_recepisse && item.numero_recepisse.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesStartDate = start ? itemDate >= start : true;
        const matchesEndDate = end ? itemDate <= end : true;

        return matchesSearchTerm && matchesStartDate && matchesEndDate;
    });

    const headers = ['N° Récepissé', "Référence fiscale", "date de Création", "Motif"];
    const formattedData = filteredData.map((item) => [
        item.numero_recepisse,
        item.reference_fiscal,
        <DateFormatConverter isoDate={item.date_creation} />,
        item.motif
    ]);

    // Fonction pour gérer le clic sur une ligne du tableau
    const handleTableRowClick = (rowIndex) => {
        if (selectedRowIndex === rowIndex) {
            setSelectedRowIndex(null);
            setDataSelected(null);
        } else {
            setSelectedRowIndex(rowIndex);
            const selectedRowData = filteredData[rowIndex];
            setDataSelected(selectedRowData);
        }
    };

    useEffect(() => {
        localStorage.setItem("selectedDataMouvementHistorique", JSON.stringify(dataSelected));
        console.log(dataSelected);
    }, [dataSelected]);

    // Fonction pour imprimer le tableau
    const handlePrint = () => {
        const originalContents = document.body.innerHTML;
        const printContents = document.getElementById('printable-table').innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload(); // Recharger la page après l'impression
    };

    let navigate = useNavigate();
    const contentChildren = (
        <div className='flex justify-center items-center '>
            <div className='flex flex-col p-4 '>
                <div className='flex flex-row'>
                    <SearchInput className={"mt-8"} onChange={(e) => setSearchTerm(e.target.value)} />
                    <div className='flex flex-col ml-2'>
                        <Label text="Du"></Label>
                        <Input type='date' className="mt-4" onChange={(e) => setStartDate(e.target.value)} />
                    </div>
                    <div className='flex flex-col ml-2'>
                        <Label text="Au"></Label>
                        <Input type='date' className="mt-4" onChange={(e) => setEndDate(e.target.value)} />
                    </div>
                </div>
                <div className='flex justify-center mt-4 ' id="printable-table">
                    <Table 
                        headers={headers} 
                        data={formattedData} 
                        classTable="overflow-y-auto "
                        onClick={handleTableRowClick} selectedRowIndex={selectedRowIndex}// Passer l'index de la ligne sélectionnée
                    />
                </div>
                <div className='flex justify-between  mt-4'>
                    <Button children="Imprimer" onClick={handlePrint} />
                    <Button children="Voir en Detail" onClick={() => { navigate('/VoirEnDetailHistorique') }} />
                </div>
            </div>
        </div>
    );

    return (
        <div className='bg-[#212122]  h-full w-full'>
            <Layout currentPath={location.pathname} children={contentChildren}></Layout>
        </div>
    );
}

export default MouvementHistorique;
